// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3Rr8Q","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__bXGPC","gfeWrapper":"CalendarEvent_gfeWrapper__3fq9z"};